var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentSelectGuideUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D8F0E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 15,
    r: 5.25,
    fill: "#2F7A64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 29.25c0-4.28 3.8-7.75 9.5-7.75s9.5 3.47 9.5 7.75c0 .69-.56 1.25-1.25 1.25H11.75c-.69 0-1.25-.56-1.25-1.25Z",
    fill: "#2F7A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentSelectGuideUser);
export default __webpack_public_path__ + "static/media/student-select-guide-user.c613050d0b5854f8a20ecdc780650dec.svg";
export { ForwardRef as ReactComponent };